
export default function format(valor){
                const singular={
                //Tipus
                convencional:"Convencional",
                universitaria:"Universitària",
                internacional:"Internacional",
                aficionats:"d'Aficionats",
                efimera:"Efímera",
                projecte:"Projecte",
                seccio:"Secció",
                ficticia:"Fictícia",

                //Estats
                activa:"Activa",
                formacio:"En formació",
                desapareguda:"Desapareguda"
            };

                const plural={
                //Tipus
                convencional:"Convencionals",
                universitaria:"Universitàries",
                internacional:"Internacionals",
                aficionats:"d'Aficionats",
                efimera:"Efímeres",
                projecte:"Projecte",
                seccio:"Secció",
                ficticia:"Fictícies",

                //Estats
                activa:"Actives",
                formacio:"En formació",
                desapareguda:"Desaparegudes"
            };

                const faIcon={
                //Tipus
                convencional:['fas', 'house'],
                universitaria:['fas', 'graduation-cap'],
                internacional:['fas', 'earth-americas'],
                aficionats:['fas', 'arrows-to-dot'],
                efimera:['fas', 'hourglass-half'],
                projecte:['fas', 'lightbulb'],
                seccio:['fas','chart-pie'],
                ficticia:['fas','film'],

                //Estats
                activa:['fas', 'fire'],
                formacio:['fas', 'seedling'],
                desapareguda:['fas', 'cross']

                }
            return {plural: plural[valor]|| "Desconegut",
                    singular: singular[valor]|| "Desconegut",
                    icon: faIcon[valor] || ['fas', 'circle-question']
            }
            }